import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { HubContextInitialState, HubContextListLoad, HubContextSelectItem } from './hub-context.actions';
import { HubContextState } from './hub-context.state';
import { HubBrief } from '../models/hub.model';

@Injectable({ providedIn: 'root' })
export class HubContextFacade implements LoadDataFacade, SetInitialStateFacade {
  items$: Observable<HubBrief[]> = this.store.select(HubContextState.getItems);
  activeItems$: Observable<HubBrief[]> = this.store.select(HubContextState.getActiveItems);
  selectedHub$: Observable<HubBrief> = this.store.select(HubContextState.getSelectedItem);
  contextTimezone$: Observable<string> = this.store.select(HubContextState.getContextTimezone);
  loaded$: Observable<boolean> = this.store.select(HubContextState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new HubContextListLoad());
  }

  setHubContext(hub: HubBrief): void {
    this.store.dispatch(new HubContextSelectItem(hub));
  }

  setInitialState(): void {
    this.store.dispatch(new HubContextInitialState());
  }

  getSelectedHubSnapshot(): HubBrief | null {
    return this.store.selectSnapshot(HubContextState.getSelectedItem);
  }
}
